import Home from './components/Home/Home'
import './app.css'

function App() {
  return (
    <div className="capitol-noir">
      <Home />
    </div>
  )
}

export default App
